<div class="image-viewer" *ngIf="src" (click)="close()">
  <fa-icon (click)="close()" icon="times" class="circle-icon-btn close-btn"></fa-icon>
  <img style="opacity: 0; transform: scaleX(0) scaleY(0);" [src]="src" />
</div>